(function () {
  'use strict';

  const ADVANCE_DELAY = 280;

  // Le calcul du gagnant vit dans eloence-quiz-profile.js (fonction pure, testée).
  // Ici : on relie l'identifiant gagnant à sa Recommendation (page résultat ou produit).
  function destinationFor(perfume, matches) {
    const usable = matches.filter((m) => m.url || m.handle);
    const match = usable.find((m) => m.perfume === perfume) || usable[0] || null;
    const path = match ? match.url || '/products/' + match.handle : '/collections/all';
    const url = new URL(path, window.location.origin);
    url.searchParams.set('utm_source', 'quiz');
    url.searchParams.set('utm_medium', 'match');
    url.searchParams.set('utm_campaign', 'scent_signature');
    url.searchParams.set('profil', perfume);
    return url.toString();
  }

  // Éditeur uniquement : combinaisons, réponses sans parfum, parfums sans destination.
  function renderAudit(root, steps, matches) {
    const box = root.querySelector('[data-el-quiz-audit]');
    if (!box) return;
    const perfumes = window.ElQuizProfile.PERFUMES;
    let combos = 1;
    const orphans = [];
    steps.forEach((step, i) => {
      const tiles = [...step.querySelectorAll('[data-el-quiz-answer]')];
      combos *= tiles.length;
      tiles.forEach((t) => { if (!t.dataset.perfume) orphans.push('Q' + (i + 1) + ' · ' + t.dataset.value); });
    });
    const noDest = perfumes.filter((p) => !matches.some((m) => m.perfume === p && (m.url || m.handle)));
    const esc = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    let html = '<strong>Contrôle du quiz (visible seulement dans l\'éditeur)</strong><br>' +
      steps.length + ' question(s) · <strong>' + combos.toLocaleString('fr-FR') + ' combinaisons possibles</strong>';
    if (orphans.length) {
      html += '<br>⚠ ' + orphans.length + ' réponse(s) sans parfum (elles ne rapportent aucun point) :<ul>' +
        orphans.map((o) => '<li>' + esc(o) + '</li>').join('') + '</ul>';
    }
    if (noDest.length) {
      html += '<br>⚠ Parfum(s) sans Recommendation avec page ou produit : ' + noDest.map(esc).join(', ') +
        ' — s\'il gagne, la personne est envoyée vers la première Recommendation active.';
    }
    if (!orphans.length && !noDest.length) html += '<br>✓ Chaque réponse a un parfum, chaque parfum a une destination.';
    box.innerHTML = html;
  }

  function init(root) {
    if (root.__elQuizReady) return;
    const steps = [...root.querySelectorAll('[data-el-quiz-step]')];
    const panels = [...root.querySelectorAll('[data-el-quiz-panel]')];
    if (!steps.length) return;
    root.__elQuizReady = true;

    const prev = root.querySelector('[data-el-quiz-prev]');
    const confirm = root.querySelector('[data-el-quiz-confirm]');
    const confirmText = root.querySelector('[data-el-quiz-confirm-text]');
    const counter = root.querySelector('[data-el-quiz-counter]');
    const fill = root.querySelector('[data-el-quiz-progress]');
    let config = { matches: [] };
    try { config = JSON.parse(root.querySelector('[data-el-quiz-config]').textContent); } catch (_) {}
    const matches = config.matches || [];

    const picked = new Array(steps.length).fill(null); // libellé choisi
    const answers = new Array(steps.length).fill(null); // parfum tagué (null si aucun)
    let current = 0;
    let locked = false;

    function show(idx, focus) {
      current = idx;
      panels.forEach((p) => { p.hidden = p !== steps[idx]; });
      if (counter) counter.textContent = 'Question ' + (idx + 1) + ' / ' + steps.length;
      if (fill) fill.style.width = ((idx + 1) / steps.length) * 100 + '%';
      if (prev) prev.hidden = idx === 0;
      if (confirm) {
        confirm.disabled = !picked[idx];
        const last = idx === steps.length - 1;
        confirmText.textContent = last ? confirm.dataset.labelLast : confirm.dataset.labelNext;
      }
      if (focus) {
        const h = steps[idx].querySelector('.el-qz__question');
        if (h) h.focus({ preventScroll: true });
        root.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }

    function advance() {
      if (current === steps.length - 1) {
        locked = true;
        try { sessionStorage.setItem('el_quiz_answers', JSON.stringify(picked)); } catch (_) {}
        if (confirm) confirm.disabled = true;
        const winner = window.ElQuizProfile.computeProfile(answers);
        window.location.href = destinationFor(winner, matches);
        return;
      }
      show(current + 1, true);
    }

    root.addEventListener('click', (e) => {
      if (locked) return;
      const tile = e.target.closest('[data-el-quiz-answer]');
      if (tile) {
        const step = tile.closest('[data-el-quiz-step]');
        const idx = steps.indexOf(step);
        if (idx !== current) return;
        step.querySelectorAll('[data-el-quiz-answer]').forEach((b) => {
          b.setAttribute('aria-pressed', b === tile ? 'true' : 'false');
        });
        picked[idx] = tile.dataset.value;
        answers[idx] = tile.dataset.perfume || null;
        if (confirm) { confirm.disabled = false; return; }
        locked = true;
        setTimeout(() => { locked = false; advance(); }, ADVANCE_DELAY);
        return;
      }
      if (confirm && e.target.closest('[data-el-quiz-confirm]') && picked[current]) {
        advance();
        return;
      }
      if (e.target.closest('[data-el-quiz-prev]') && current > 0) {
        show(current - 1, true);
      }
    });

    // Retour arrière depuis la page résultat (cache navigateur) : débloquer le quiz.
    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      locked = false;
      show(current, false);
    });

    // Éditeur Shopify : sélectionner un bloc Question affiche cette question.
    root.addEventListener('shopify:block:select', (e) => {
      const idx = steps.indexOf(e.target);
      if (idx > -1) { show(idx, false); return; }
      if (panels.includes(e.target)) panels.forEach((p) => { p.hidden = p !== e.target; });
    });

    renderAudit(root, steps, matches);
    show(0, false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-el-quiz]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
